import React, { useMemo, useState } from "react";
import { FiArrowRight, FiClock, FiUsers } from "react-icons/fi";
import { Link } from "react-router-dom";
import PageMeta from "../components/common/PageMeta";
import siteConfig from "../config/siteConfig";
import recipes from "../data/recipes";

const RecipeCard = ({ recipe, featured = false }) => (
  <article className={`recipe-card ${featured ? "recipe-card--featured" : ""}`}>
    <Link className="recipe-card__image" to={`/recipes/${recipe.slug}`}><img src={recipe.image} alt={recipe.title} loading={featured ? "eager" : "lazy"} /></Link>
    <div className="recipe-card__content">
      <p className="eyebrow">{recipe.cuisine}</p>
      <h2><Link to={`/recipes/${recipe.slug}`}>{recipe.title}</Link></h2>
      <p>{recipe.excerpt}</p>
      <div className="recipe-card__meta"><span><FiClock /> {recipe.totalTime} min</span><span><FiUsers /> Serves {recipe.servings}</span><span>{recipe.difficulty}</span></div>
      <Link className="recipe-card__link" to={`/recipes/${recipe.slug}`}>Read recipe <FiArrowRight /></Link>
    </div>
  </article>
);

const RecipesPage = () => {
  const [filter, setFilter] = useState("all");
  const tags = useMemo(() => ["all", ...new Set(recipes.flatMap((recipe) => recipe.tags))], []);
  const filtered = filter === "all" ? recipes : recipes.filter((recipe) => recipe.tags.includes(filter));
  const [featured, ...rest] = filtered;

  return (
    <div className="recipes-page">
      <PageMeta title="Recipes" description={`Flavor-forward recipes designed around the ${siteConfig.displayName} pantry.`} />
      <header className="recipes-hero"><div className="site-container"><p className="eyebrow">The recipe archive</p><h1>Cook something vivid.</h1><p>Practical recipes that show every jar exactly where it can go.</p></div></header>
      <div className="site-container recipes-page__content">
        <nav className="recipe-filters" aria-label="Filter recipes"><span>Filter by</span>{tags.map((tag) => <button type="button" className={filter === tag ? "is-active" : ""} onClick={() => setFilter(tag)} key={tag}>{tag.replace(/-/g, " ")}</button>)}</nav>
        {featured ? <><RecipeCard recipe={featured} featured /><div className="recipe-grid">{rest.map((recipe) => <RecipeCard recipe={recipe} key={recipe.id} />)}</div></> : <p className="recipes-page__empty">No recipes match that filter yet.</p>}
      </div>
    </div>
  );
};

export { RecipeCard };
export default RecipesPage;
